/* Outdoors Nordic. Flyttad ur blocks/on-product-tabs.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */

  (function () {
if (window.__onProductTabs) return;
window.__onProductTabs = true;
var CHECK = '<svg viewBox="0 0 24 24" fill="#2d9cdb"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm-1.2 14.2l-4-4 1.4-1.4 2.6 2.6 5.6-5.6L17.8 9l-7 7.2z"/></svg>';
/* Stjärndesign (omgång 91): betyget till on-sr-behållaren runt fyllnaden. */
function onSrSet(el, r){ var s = el && el.closest && el.closest('.on-sr'); if (!s) return; r = Math.max(0, Math.min(5, +r || 0)); var f = Math.floor(r); s.style.setProperty('--on-sf', f); s.style.setProperty('--on-sp', Math.round((r - f) * 100) / 100); if (window.__onSr && s.hasAttribute('aria-label')) { var m = /aria-label="([^"]*)"/.exec(window.__onSr(r).attrs); if (m) s.setAttribute('aria-label', m[1].replace(/&quot;/g, '"')); } }
function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':String(s); return d.innerHTML; }
/* Landsflagga per recension. Loox storefront-API skickar INGET land - kartan
 kommer fran feed-metafalten via on-review-flags. Recensioner som inte finns
 i feeden far ingen flagga, samma regel som i varukorgen: hellre ingen flagga
 an en gissad ur spraket (de = DE/AT/CH). */
var RVFLAGS = {}, RVSVG = {};
(function () {
var src = document.querySelector('.on-rvflags') || document.querySelector('.on-rvflags');
if (!src) return;
(src.getAttribute('data-flags') || '').split(';').forEach(function (pair) {
  var p = pair.split(':');
  if (p.length === 2 && p[0] && p[1]) RVFLAGS[p[0]] = p[1];
});
var tpl = src.querySelector('[data-rvflags]') || document.querySelector('[data-rvflags]');
if (tpl && tpl.content) tpl.content.querySelectorAll('i[data-code]').forEach(function (n) {
  RVSVG[n.getAttribute('data-code')] = n.innerHTML;
});
})();
/* Allt-eller-inget per produkt. Loox skriver feed-metafaltet (enda kallan med
 land) bara for produkter som fatt en recension pa sistone - 16 av 49 har det.
 En flagga pa 3 av 24 kort ser trasigt ut; ingen flagga alls ser avsiktligt ut.
 Tacker kartan minst 80% av korten visas flaggorna, annars inga. */
var SHOWFLAGS = true;
function flagCoverage(list) {
var n = Math.min(list.length, 24), hit = 0;
for (var i = 0; i < n; i++) { if (RVFLAGS[list[i] && list[i].id]) hit++; }
return n ? hit / n : 0;
}
function flagHtml(rv) {
if (!SHOWFLAGS) return '';
var iso = RVFLAGS[rv && rv.id];
if (!iso || !RVSVG[iso]) return '';
return '<span class="opt__rflag" title="' + esc(iso) + '">' + RVSVG[iso] + '</span>';
}
/* Datum pa besokarens sprak, med ar. Samma format som varukorgen. */
function dateHTML(iso, lang){
if (!iso) return '';
var d = new Date(iso); if (isNaN(d)) return '';
var s; try { s = d.toLocaleDateString(lang || 'sv', { year: 'numeric', month: 'short', day: 'numeric' }); }
catch (e) { s = d.toISOString().slice(0, 10); }
return '<time class="opt__rdate" datetime="' + esc(iso) + '">' + esc(s) + '</time>';
}
function starsHTML(r){ var p=Math.max(0,Math.min(100,(r/5)*100)); var a = window.__onSr ? window.__onSr(r, 14) : { style: '', attrs: '' }; return '<span class="opt__rstars on-sr" style="' + a.style + '" ' + a.attrs + '><span class="opt__rstars-b">★★★★★</span><span class="opt__rstars-f" style="width:'+p+'%">★★★★★</span></span>'; }
/* Översättning: samma väg som Loox-karusellen (MyMemory), så butiken har EN
metod för recensionsöversättning och inte två som beter sig olika. */
function translate(text, from, to){
var chunk = String(text || '').slice(0, 480);
var mail = document.querySelector('on-product-tabs');
var de = mail ? (mail.getAttribute('data-tremail') || '') : '';
var u = 'https://api.mymemory.translated.net/get?q=' + encodeURIComponent(chunk) +
      '&langpair=' + from + '|' + to + (de ? '&de=' + encodeURIComponent(de) : '');
return fetch(u).then(function(r){ return r.json(); }).then(function(d){
var t = d && d.responseData && d.responseData.translatedText;
/* MyMemory svarar 200 OK med ETT FELMEDDELANDE som "oversattning" nar
   kall- och malsprak ar samma: responseStatus "403" och texten
   "PLEASE SELECT TWO DISTINCT LANGUAGES". Utan den har kontrollen
   skrevs felmeddelandet rakt in i recensionen. Statusen ar en STRANG. */
var st = d && d.responseStatus;
if (st && String(st) !== '200') return null;
if (!t || /MYMEMORY WARNING|QUOTA|INVALID|YOU USED ALL|DISTINCT LANGUAGES|PLEASE SELECT/i.test(t)) return null;
return t;
}).catch(function(){ return null; });
}
function bindTranslate(root, track){
if (track.dataset.trBound) return;
track.dataset.trBound = '1';
var TARGET = (root.getAttribute('data-lang') || 'en').slice(0, 2);
var TTR = root.getAttribute('data-trlabel') || 'Translate';
var TORIG = root.getAttribute('data-origlabel') || 'Show original';
track.addEventListener('click', function(e){
var btn = e.target.closest('[data-tr]'); if (!btn) return;
var card = btn.closest('.opt__rcard');
var body = card.querySelector('.opt__rbody');
if (card.dataset.translated === '1') {          // tillbaka till originalet
  body.textContent = body.getAttribute('data-orig');
  card.dataset.translated = '0'; btn.textContent = TTR; return;
}
if (card.dataset.trCache) {                     // redan hämtad en gång
  body.textContent = card.dataset.trCache;
  card.dataset.translated = '1'; btn.textContent = TORIG; return;
}
btn.disabled = true;
var from = card.getAttribute('data-from') || 'Autodetect';
if (from !== 'Autodetect') from = from.slice(0, 2);
var orig = body.getAttribute('data-orig');
translate(orig, from, TARGET)
  .then(function(out){
    btn.disabled = false;
    // Ingen text tillbaka, eller exakt samma text = ingen översättning skedde.
    // Då ska knappen INTE påstå att den gjort något; den ställs tillbaka.
    if (!out || out.trim() === (orig || '').trim()) {
      card.dataset.translated = '0';
      btn.textContent = TTR;
      return;
    }
    card.dataset.trCache = out; card.dataset.translated = '1';
    body.textContent = out; btn.textContent = TORIG;
  });
});
}
function loadReviews(root){
var box = root.querySelector('[data-rev]');
if (!box || box.dataset.loaded) return;
box.dataset.loaded = '1';
var track = box.querySelector('[data-track]');
var store = root.getAttribute('data-store');
var pid = root.getAttribute('data-product');
var TVER = box.getAttribute('data-verified') || 'Verified buyer';
var TRANSLATE = root.getAttribute('data-translate') === 'true';
var LANG = root.getAttribute('data-lang') || 'sv';
var SHOWDATE = root.getAttribute('data-date') !== 'false';
var TTR = root.getAttribute('data-trlabel') || 'Translate';
track.innerHTML = '<div class="opt__state">' + esc(box.getAttribute('data-loading')) + '</div>';
if (!store) { track.innerHTML = '<div class="opt__state">' + esc(box.getAttribute('data-empty')) + '</div>'; return; }
var pool = [], page = 1, guard = 0, apiTotal = 0, apiAvg = 0;
/* Reservkallor. source styr bade vilken text som visas under korten och
 att sammanfattningen INTE far para produktens egna metafalt med siffror
 som beskriver en annan mangd recensioner. */
var FB = box.getAttribute('data-fb') || 'linked_store';
var FBPID = box.getAttribute('data-fbpid') || '';
var source = 'own';
/* Sammanfattningen räknas ur produktens FAKTISKA recensioner. Den låg förut
 enbart på metafälten loox.avg_rating/num_reviews, som saknas på många
 produkter – då försvann hela sammanfattningen. Nu fyller vi den från samma
 hämtning som korten, och metafältet används bara som startvärde. */
function fillSummary(list){
var sum = root.querySelector('[data-revsum]');
if (!sum || !list || !list.length) return;
var tot = 0, n = 0;
list.forEach(function(rv){
  var r = parseFloat(rv.rating);
  if (!isNaN(r)) { tot += r; n++; }
});
if (!n) return;
 /* Butiksbreda recensioner: da finns ingen siffra som ARLIGT kan sta som
   produktens betyg. Loox ger inget snitt for hela butiken via API:t, och
   urvalets snitt over produktens namn skulle lasas som just den produktens.
   Stjarnraden doljs helt i det laget - notisen och korten racker. */
/* Butiksbreda kort: betyget ska da vara BUTIKENS, samma siffra som visas
   hogst upp pa sidan. Att dolja raden helt lamnade en tom stjarnrad. */
if (source === 'store' && !(apiAvg > 0)) {
  var sMean = parseFloat(sum.getAttribute('data-store-mean') || '');
  var sCount = parseInt(sum.getAttribute('data-store-count') || '0', 10);
  if (!isNaN(sMean) && sMean > 0) {
    var mEl = sum.querySelector('[data-revsum-mean]');
    var fEl = sum.querySelector('[data-revsum-fill]');
    var cEl = sum.querySelector('[data-revsum-count]');
    if (mEl) mEl.textContent = String(Math.round(sMean * 10) / 10).replace('.', ',') + '/5';
    if (fEl) { fEl.style.width = Math.round(sMean * 20) + '%'; onSrSet(fEl, sMean); }
    if (cEl && sCount) {
      cEl.textContent = (sum.getAttribute('data-word-of') || '') + ' ' + sCount + ' ' +
                        (sum.getAttribute('data-word-reviews') || '');
    }
    sum.hidden = false;
    return;
  }
  sum.hidden = true;
  return;
}
 /* Betyg och antal MÅSTE beskriva samma mängd. Snittet av de ~24 hämtade
   recensionerna ihop med totalen (t.ex. "4,7 av 2211") är ett falskt påstående:
   4,7 gällde bara urvalet. Prioritet:
     1. Loox eget snitt  → gäller alla, får paras med totalen
     2. metafältet       → samma sak, satt från Loox
     3. urvalets snitt   → paras då med URVALETS antal, aldrig med totalen  */
var sampleMean = Math.round((tot / n) * 10) / 10;
/* Siffrorna maste beskriva samma mangd som korten. Nar korten kommer fran
   den lankade modellen ar det MOTPARTENS Loox-siffror som galler - inte den
   har produktens (kopierade) metafalt, och inte urvalets snitt ihop med en
   total som beskriver nagot annat. */
var mfMean = NaN, mfCount = 0;
if (source === 'own') { mfMean = parseFloat(sum.getAttribute('data-mf-mean') || ''); mfCount = parseInt(sum.getAttribute('data-mf-count') || '0', 10); }
else if (source === 'linked') { mfMean = parseFloat(sum.getAttribute('data-cp-mean') || ''); mfCount = parseInt(sum.getAttribute('data-cp-count') || '0', 10); }
var mean, count;
if (apiAvg > 0) {
  mean = Math.round(apiAvg * 10) / 10;
  count = apiTotal || n;
} else if (!isNaN(mfMean) && mfMean > 0) {
  mean = Math.round(mfMean * 10) / 10;
  /* Metafaltet gar FORE API-totalen: loox.num_reviews ar Loox egen
     aggregerade siffra for produkten, och det ar den som announcement-baren,
     prisraden och Loox-betyg (ON) visar. API:ts pagination.total raknar bara
     de recensioner feeden serverar (t.ex. utan de som saknar text), vilket gav
     tva olika tal pa samma sida - 2277 uppe och 2216 har. */
  count = mfCount || apiTotal || n;
} else {
  mean = sampleMean;
  count = n;
}
var meanEl = sum.querySelector('[data-revsum-mean]');
var starEl = sum.querySelector('[data-revsum-fill]');
var cntEl  = sum.querySelector('[data-revsum-count]');
if (meanEl) meanEl.textContent = String(mean).replace('.', ',') + '/5';
if (starEl) { starEl.style.width = Math.round(mean * 20) + '%'; onSrSet(starEl, mean); }
if (cntEl && count) {
  // Orden kommer från Liquid, alltså redan på besökarens språk.
  cntEl.textContent = (sum.getAttribute('data-word-of') || '') + ' ' + count + ' ' +
                      (sum.getAttribute('data-word-reviews') || '');
}
sum.hidden = false;
}
function step(useId){
/* sort=date = Loox nyaste forst (verifierat mot API:t; utan parametern kom
   ett ars gamla recensioner forst). limit=20 halverar antalet anrop. */
var url = 'https://storefront-api.loox.io/storefront/v1/store/' + store + '/product-reviews?limit=20&sort=date&page=' + page;
if (useId) url += '&product_id=' + encodeURIComponent(useId);
return fetch(url, { headers: { Accept: 'application/json' } })
  .then(function(r){ if(!r.ok) throw new Error('http'); return r.json(); })
  .then(function(data){
    (data.reviews || []).forEach(function(rv){
      if (useId && String(rv.product && rv.product.id) !== String(useId)) return;
      pool.push(rv);
    });
    guard++;
    // Totalen kommer från API:t när den finns – pool.length är bara de
    // hämtade sidorna och skulle undervärdera antalet grovt.
    var gs = data.global_stats;
    if (gs && gs.total) apiTotal = gs.total;
    else if (data.pagination && data.pagination.total) apiTotal = data.pagination.total;
    // Loox EGET snitt när det finns – det gäller alla recensioner, till skillnad
    // från snittet av de sidor vi råkat hämta.
    if (gs) {
      var a = gs.avg_rating || gs.average_rating || gs.rating || gs.avg;
      if (a) { var pa = parseFloat(a); if (!isNaN(pa) && pa > 0) apiAvg = pa; }
    }
    var more = data.pagination && data.pagination.hasMore;
    if (more && pool.length < 24 && guard < 8) { page++; return step(useId); }
    return pool;
  });
}
function reset(){ pool = []; page = 1; guard = 0; apiTotal = 0; apiAvg = 0; }
step(pid)
.then(function(list){
  /* Ingen egen recension: ta den lankade modellens. Loox gruppering ger
     oss inget har, sa kopplingen maste goras pa var sida. */
  if (list.length || FB === 'none') return list;
  if ((FB === 'linked' || FB === 'linked_store') && FBPID) { reset(); source = 'linked'; return step(FBPID); }
  return list;
})
.then(function(list){
  if (list.length || FB === 'none' || FB === 'linked') return list;
  reset(); source = 'store'; return step(null);
})
.then(function(list){
var note = box.querySelector('[data-revnote]');
if (note && list.length && source !== 'own') {
  /* Sammanfattningen visar butikens betyg har - se fillSummary. */
  note.textContent = box.getAttribute(source === 'linked' ? 'data-fb-linked' : 'data-fb-store') || '';
  note.hidden = false;
}
/* Nyaste forst - annars visades alltid samma handfull femmor och nya
   recensioner syntes aldrig, hur manga som an kom in. */
/* Lokala recensioner forst. En tysk kund ska mota tyska recensioner, inte
   svenska hen inte forstar; Loox skickar originalLanguage per recension.
   Inom varje grupp galler fortfarande nyast forst. */
var vLang = (root.getAttribute('data-lang') || '').slice(0, 2).toLowerCase();
function isNb(x){ return x === 'no' || x === 'nb' || x === 'nn'; }
function isLocal(rv){
  var l = (rv.originalLanguage || '').slice(0, 2).toLowerCase();
  if (!l || !vLang) return false;
  if (l === vLang) return true;
  return isNb(vLang) && isNb(l);
}
list.sort(function(a,b){
  var d = (isLocal(b) ? 1 : 0) - (isLocal(a) ? 1 : 0);
  return d || (new Date(b.date)-new Date(a.date)) || (b.rating-a.rating);
});
if (!list.length) { track.innerHTML = '<div class="opt__state">' + esc(box.getAttribute('data-empty')) + '</div>'; return; }
SHOWFLAGS = flagCoverage(list) >= 0.8;
track.innerHTML = list.slice(0,24).map(function(rv){
  var name = rv.reviewer && rv.reviewer.name;
  var body = rv.body == null ? '' : String(rv.body);
  // Loox skickar inte alltid med språket. Gissa inte "en" då – MyMemory får
  // autodetektera i stället, annars översätts finska som om den vore engelsk
  // och texten kommer tillbaka oförändrad.
  /* Loox falt heter originalLanguage i storefront-API:t - rv.language finns
     INTE, sa varje recension gick in som 'Autodetect' och svenska recensioner
     pa svensk sida skickades till oversattning (sv->sv = felmeddelande). */
  var rlang = String(rv.originalLanguage || rv.language || '').split('-')[0].toLowerCase();
  var canTr = TRANSLATE && body && rlang !== LANG.slice(0, 2);
  return '<article class="opt__rcard" data-from="' + esc(rlang || 'Autodetect') + '">' +
    '<div class="opt__rhead">' + flagHtml(rv) + '<span class="opt__rname">' + esc(name) + '</span>' +
      (rv.verified ? '<span class="opt__rvrf">' + CHECK + esc(TVER) + '</span>' : '') + '</div>' +
    '<div class="opt__rmeta">' + starsHTML(rv.rating || 5) +
      (SHOWDATE ? dateHTML(rv.date, LANG) : '') + '</div>' +
    '<p class="opt__rbody" data-orig="' + esc(body) + '">' + esc(body) + '</p>' +
    (canTr ? '<button type="button" class="opt__rtr" data-tr>' + esc(TTR) + '</button>' : '') +
  '</article>';
}).join('');
fillSummary(list);
if (TRANSLATE) bindTranslate(root, track);
}).catch(function(){ track.innerHTML = '<div class="opt__state">' + esc(box.getAttribute('data-empty')) + '</div>'; });
}
function bindNav(root){
var track = root.querySelector('[data-track]'); if(!track) return;
var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
function w(){ var c = track.querySelector('.opt__rcard'); return c ? c.offsetWidth + 14 : 300; }
if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -w(), behavior: 'smooth' }); });
if (next) next.addEventListener('click', function(){ track.scrollBy({ left: w(), behavior: 'smooth' }); });
}
/* Videon laddas först när fliken öppnas – annars drar varje produktsidvisning
hem filen i onödan. Autoplay kan nekas (t.ex. strömsparläge); då visas
poster-bilden och inget kraschar. */
function startVideo(root){
var v = root.querySelector('[data-opt-video]');
if (!v || v.dataset.started) return;
v.dataset.started = '1';
/* autoplay stod forut i markupen. Chrome struntar da i preload="none" och drog
 hem hela filen pa varje produktsidvisning (matt: 1,8 MB). Bade autoplay och
 sjalva kallorna satts darfor forst har, nar fliken faktiskt oppnas. */
var mall = root.querySelector('template[data-opt-src]');
if (mall && !v.querySelector('source')) v.appendChild(mall.content.cloneNode(true));
v.muted = true;
v.autoplay = true;
v.preload = 'auto';
try { v.load(); } catch (e) {}
var p = v.play();
if (p && p.catch) p.catch(function(){});
}
/* Recensionsspåret gick bara att svepa på mobil. På datorn: dra med musen och
scrolla med hjulet i sidled. Klick på ett kort blockeras bara om man faktiskt
drog (över 4 px), annars går länkar i kortet fortfarande att klicka. */
function bindDrag(root){
var track = root.querySelector('[data-track]');
if (track) bindScroller(track);
}
function bindScroller(track){
if (!track || track.dataset.dragBound) return;
track.dataset.dragBound = '1';
var down = false, moved = 0, startX = 0, startLeft = 0;
var captured = false;
track.addEventListener('pointerdown', function(e){
if (e.pointerType === 'touch') return;          // mobilen sköts av native swipe
down = true; moved = 0; captured = false; startX = e.clientX; startLeft = track.scrollLeft;
// INGEN setPointerCapture här. Fångar man pekaren direkt vid nedtryck byter
// det efterföljande klicket måltavla till behållaren, och knappar/flikar
// inuti slutar gå att klicka. Capture sker först när det ÄR ett drag.
});
track.addEventListener('pointermove', function(e){
if (!down) return;
var dx = e.clientX - startX;
if (!captured && Math.abs(dx) > 4) {
  captured = true;
  track.classList.add('is-dragging');
  try { track.setPointerCapture(e.pointerId); } catch (err) {}
}
if (!captured) return;                          // under tröskeln = vanligt klick
moved = Math.abs(dx);
track.scrollLeft = startLeft - dx;
});
function end(e){
if (!down) return;
down = false;
track.classList.remove('is-dragging');
if (captured) { try { track.releasePointerCapture(e.pointerId); } catch (err) {} }
captured = false;
}
track.addEventListener('pointerup', end);
track.addEventListener('pointercancel', end);
track.addEventListener('click', function(e){ if (moved > 4) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
track.addEventListener('wheel', function(e){
if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;   // redan sidledes
if (track.scrollWidth <= track.clientWidth) return;      // inget att scrolla
track.scrollLeft += e.deltaY;
e.preventDefault();
}, { passive: false });
}
function init(root){
if (root.dataset.optInit) return; root.dataset.optInit = '1';
var tabs = root.querySelectorAll('.opt__tab');
var panels = root.querySelectorAll('.opt__panel');
root.querySelector('.opt__tabs').addEventListener('click', function(e){
var btn = e.target.closest('.opt__tab'); if (!btn) return;
var key = btn.getAttribute('data-panel');
// I "alla stängda"-läget stänger ett klick på den redan öppna fliken den igen.
if (root.getAttribute('data-closable') === '1' && btn.classList.contains('is-active')) {
  btn.classList.remove('is-active');
  panels.forEach(function(p){ p.classList.remove('is-active'); });
  return;
}
tabs.forEach(function(t){ t.classList.toggle('is-active', t === btn); });
panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
if (key === 'rev') loadReviews(root);
if (key === 'vid') startVideo(root);
// Aktivitetskorten mäts först när panelen syns (rubriken krymper hellre än bryts).
if (key === 'act' && window.onFitSizes) setTimeout(window.onFitSizes, 0);
});
bindNav(root);
bindDrag(root);
// Flikraden scrollar redan i sidled, men bara med svep. Samma drag/hjul som
// recensionerna så många flikar går att nå även med mus.
var tabsEl = root.querySelector('.opt__tabs');
if (tabsEl) bindScroller(tabsEl);
var actNow = root.querySelector('.opt__panel.is-active');
if (actNow && actNow.getAttribute('data-panel') === 'vid') startVideo(root);
// Om recensions-fliken är aktiv direkt (enda fliken) → ladda.
var act = root.querySelector('.opt__panel.is-active');
if (act && act.getAttribute('data-panel') === 'rev') loadReviews(root);
}
function boot(){ document.querySelectorAll('on-product-tabs').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
  })();

